import { useState } from 'react';
import { Modal } from 'antd';
import classNames from 'classnames';
import { Check, ChevronDown, Sparkles } from 'lucide-react';
import styles from './EngineSwitchNotice.module.scss';

const SUMMARY = '超级自研学术特调模型会更深入地分析题目，章节与图表方案更完整，内容质量更高。';

const DIFFERENCES = [
    '更深入地分析题目，章节安排更完整',
    '每张图表都附带类型、目的与布局说明，写作时按说明生成配图',
    '正文由特调模型撰写，表达更专业、内容质量更高',
];

/**
 * 普通引擎大纲页顶部的引擎提示：说明当前是普通模型的大纲，
 * 可展开查看与超级自研学术特调模型的区别，并提供切换入口（切换后重新生成大纲）。
 */
export default function EngineSwitchNotice({ disabled = false, onSwitch }) {
    const [expanded, setExpanded] = useState(false);

    const confirmSwitch = () => {
        Modal.confirm({
            title: '切换为学术特调大纲？',
            content: '将按超级自研学术特调模型重新生成大纲，当前大纲及已做的修改会被覆盖。',
            okText: '切换并重新生成',
            cancelText: '暂不切换',
            onOk: () => onSwitch?.(),
        });
    };

    return (
        <section className={styles.notice} aria-label="大纲生成引擎说明">
            <span className={styles.chip} aria-hidden>
                <Sparkles size={16} />
            </span>
            <div className={styles.copy}>
                <div className={styles.title}>当前为普通模型大纲</div>
                <p className={styles.summary}>{SUMMARY}</p>
            </div>
            <div className={styles.actions}>
                <button
                    type="button"
                    className={styles.toggle}
                    aria-expanded={expanded}
                    onClick={() => setExpanded((value) => !value)}
                >
                    {expanded ? '收起' : '了解区别'}
                    <ChevronDown
                        size={13}
                        aria-hidden
                        className={classNames(styles.chevron, { [styles.chevronOpen]: expanded })}
                    />
                </button>
                <button
                    type="button"
                    className={styles.switchBtn}
                    disabled={disabled}
                    onClick={confirmSwitch}
                >
                    切换为特调大纲
                </button>
            </div>

            {expanded && (
                <div className={styles.details}>
                    <ul className={styles.list}>
                        {DIFFERENCES.map((item) => (
                            <li key={item} className={styles.item}>
                                <Check size={13} aria-hidden />
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>
                    <p className={styles.note}>
                        切换后将按特调引擎重新生成大纲，当前大纲及修改会被覆盖。
                    </p>
                </div>
            )}
        </section>
    );
}
